// src/pages/VehiclesList.jsx
import React, { useEffect, useState } from "react";
import { Table, Button, Typography, message, Modal } from "antd";
import { getVehicles } from "../api/vehicleApi";
import CreateVehicleForm from "./CreateVehicleForm";

const { Title } = Typography;

const VehiclesList = () => {
  const [vehicles, setVehicles] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  const fetchVehicles = async () => {
    try {
      const response = await getVehicles();
      setVehicles(response.data);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      message.error("Error al obtener los vehículos");
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleSuccess = () => {
    closeModal();
    fetchVehicles();
  };

  const columns = [
    { title: "Placa", dataIndex: "plate", key: "plate" },
    { title: "Año", dataIndex: "year", key: "year" },
    { title: "VIN", dataIndex: "vin", key: "vin" },
    {
      title: "Marca",
      dataIndex: "brandInfo",
      key: "brand",
      render: (brandInfo) => (brandInfo ? brandInfo.name : ""),
    },
  ];

  return (
    <div
      style={{
        background: "#1f1f1f",
        color: "#ccc",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 10px rgba(0,0,0,0.5)",
        minHeight: "calc(100vh - 80px)",
      }}
    >
      <Title level={2} style={{ color: "#fff" }}>
        Listado de Vehículos
      </Title>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={openModal} style={{ marginRight: 8 }}>
          Crear Vehículo
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={vehicles}
        rowKey="id"
        style={{
          background: "#2a2a2a",
          color: "#ccc",
        }}
      />

      <Modal
        title={<span style={{ color: "#fff" }}>Crear Vehículo</span>}
        open={modalVisible}
        onCancel={closeModal}
        footer={null}
        destroyOnClose
        bodyStyle={{ background: "#1f1f1f", color: "#ccc" }}
      >
        <CreateVehicleForm onSuccess={handleSuccess} onCancel={closeModal} />
      </Modal>
    </div>
  );
};

export default VehiclesList;
